<div class="md-form md-outline">
  <div class="icon-container">
    <span *ngIf="loading" class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
    <jhi-bary-icon *ngIf="icon" [icon]="icon" [faDirective]="FAR"></jhi-bary-icon>
  </div>
  <ng-template [ngIf]="placeholder">
    <input
      mdbInput
      type="text"
      class="form-control"
      [maxlength]="maxlength"
      [formControl]="control"
      [id]="id"
      [mdbValidate]="true"
      [validateSuccess]="false"
      [placeholder]="placeholder"
      [name]="id"
      [readonly]="disabled"
      [value]="value"
      [class.disabled]="disabled || control.disabled"
      jhiMarkAsterisk
    />
  </ng-template>
  <ng-template [ngIf]="!placeholder">
    <input
      mdbInput
      type="text"
      class="form-control"
      [maxlength]="maxlength"
      [formControl]="control"
      [id]="id"
      [mdbValidate]="true"
      [validateSuccess]="false"
      [name]="id"
      [readonly]="disabled"
      [value]="value"
      [class.disabled]="disabled || control.disabled"
      jhiMarkAsterisk
    />
  </ng-template>
  <div class="text-danger" *ngIf="messageError != ''">
    {{ messageError }}
  </div>
  <label *ngIf="label" [for]="id">{{ label }}</label>
  <mdb-error *ngIf="control && control.invalid && (control.dirty || control.touched)">
    <span *ngIf="control.hasError('maxlength')" jhiTranslate="components.inputs.errors.max" [translateValues]="{ max: control.errors!['maxlength'].requiredLength + 1 }"></span>
    <span *ngIf="control.hasError('minlength')" jhiTranslate="components.inputs.errors.min" [translateValues]="{ min: control.errors!['minlength'].requiredLength - 1 }"></span>
    <span *ngIf="control.hasError('required')" jhiTranslate="ERROR.REQUIRED_FIELD"></span>
    <span *ngIf="control.hasError('pattern')" jhiTranslate="components.inputs.invalidPattern"></span>
    <span *ngIf="control.hasError('invalidZipCode')" jhiTranslate="ERROR.INVALID_ZIPCODE"></span>
  </mdb-error>
</div>
